module.exports = __webpack_public_path__ + "static/media/emotion-before.735ddb42.png";